import React from 'react'
import { ErrorGroupObservation } from '../domain/Error'
import { ServerRenderedDescription } from '../ui/server-rendered-description'

type Props = {
    observation: ErrorGroupObservation
}

/**
 * Displays the server-rendered (Twig + markdown) description of an observation.
 */
export const ObservationView: React.FunctionComponent<Props> = ({ observation }) => {
    const { description } = observation.observation

    if (!description) {
        return null
    }

    return <ServerRenderedDescription html={description} />
}
